export default {
    msisdn: "MSISDN",
    ratePlan: "Rate Plan",
    communicationPlan: "Communication Plan",
    dateActivated: "Date Activated",
    dateAdded: "Date Added",
    dateUpdated: "Date Updated",
    dateShipped: "Date Shipped",
    operatorCustom1: "Operator Custom 1",
    operatorCustom2: "Operator Custom 2",
    operatorCustom3: "Operator Custom 3",
    operatorCustom4: "Operator Custom 4",
    operatorCustom5: "Operator Custom 5",
    accountCustom1: "Account Custom 1",
    accountCustom2: "Account Custom 2",
    accountCustom3: "Account Custom 3",
    accountCustom4: "Account Custom 4",
    accountCustom5: "Account Custom 5",
    accountCustom6: "Account Custom 6",
    accountCustom7: "Account Custom 7",
    accountCustom8: "Account Custom 8",
    accountCustom9: "Account Custom 9",
    accountCustom10: "Account Custom 10",
    customerCustom1: "Customer Custom 1",
    customerCustom2: "Customer Custom 2",
    customerCustom3: "Customer Custom 3",
    customerCustom4: "Customer Custom 4",
    customerCustom5: "Customer Custom 5",
    simNotes: "Sim Notes",
    globalSimType: "Global Sim Type",
    mec: "MEC",
    customer: "Customer",
    Msisdn: "MSISDN",
    Imei: "IMEI",
}